export default __webpack_public_path__ + "static/weights-29d4df8f9b036e25798b8d7f175b7304.mp4";